import React from 'react';
import Pagination from "rc-pagination";
import {dateFormatOptions, dateFormatWithTimeOptions} from "../../common/dateFormatterConfig";
import {locale} from "../../common/table/paginatorConfig";
import {TankProgressBar} from "./TankProgressBar/TankProgressBar";
import { ITank } from 'models/tanks';


export function TanksTable(props: any) {
    const tanks: Array<ITank> = props.tanks.content;
    const pageResponse = props.tanks;
    const tableRows = tanks.map((tank: ITank) =>
        <tr key={'row-' + tank.id}>
            <td>
                {tank.name}
            </td>
            <td>
                <TankProgressBar tankRow={tank}/>
            </td>
            <td>
                {tank.capacity}
            </td>
            <td className={tank.latestAmount <= tank.notificationThreshold ? "under-threshold" : "over-threshold"}>
                {tank.latestAmount}
            </td>
            <td>
                {tank.notificationThreshold}
            </td>
            <td>
                {tank.latestUpdateTime ? new Intl.DateTimeFormat('et', dateFormatWithTimeOptions).format(new Date(tank.latestUpdateTime)) : ""}
            </td>
            <td>
                {tank.dateModified ? new Intl.DateTimeFormat('et', dateFormatOptions).format(new Date(tank.dateModified)) : ""}
            </td>
        </tr>
    );

    return (
        <table className='tanks__table table table-responsive-md table-hover'>
            <thead>
            <tr>
                <th>Nimetus</th>
                <th>Hetkeseis</th>
                <th>Maht</th>
                <th>Näit</th>
                <th>Teavituskünnis</th>
                <th>Näidu aeg</th>
                <th>Viimati muudetud</th>
            </tr>
            </thead>
            <tbody>
            {tableRows}
            </tbody>
            <tfoot>
            <tr>
                <td colSpan={6}>

                </td>
                <td colSpan={2}>
                    <div className="pagination-wrapper">
                        <Pagination
                            locale={locale}
                            current={pageResponse.number + 1}
                            total={pageResponse.totalElements}
                            pageSize={pageResponse.size}
                            prefixCls={"pagination"}
                            onChange={props.onPageChange}
                            showSizeChanger={false}
                            hideOnSinglePage={true}
                        />
                    </div>
                </td>
            </tr>
            </tfoot>
        </table>
    )
}